import { getDataStep } from "@/services/getData"
import { useQuery } from "@tanstack/react-query"
import useSessionStorage from "./useSessionStorage"

export default function useDataStep() {
  const [sessionPeriode] = useSessionStorage("sessionPeriode", {
    id_sys_periode: "",
  })
  const { data: dataStep, isFetched: isFetchedDataStep } = useQuery({
    queryKey: ["dataStep", sessionPeriode?.id_sys_periode],
    queryFn: () => getDataStep(sessionPeriode?.id_sys_periode || ""),
  })

  return {
    isFetchedDataStep,
    dataStep,
    isSudahKonfirmasiDataSekolah: dataStep?.is_confirm_jurusan_sekolah,
    isSudahFinalisasi: dataStep?.is_resume_pendaftaran,
    isValidasiPendaftaran: dataStep?.valid_is_pendaftaran,
  }
}
